(function () {
  if (window.twiCardNotifyBound) return;
  window.twiCardNotifyBound = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-twi-notify]');
    if (!link) return;
    var card = link.closest('.card-wrapper');
    var app = card && card.querySelector('.back-in-stock-button-collection-page, .back-in-stock-button');
    if (!app) return; // no app button: follow the link to the product page
    event.preventDefault();
    app.click();
  });
})();
